import { GenIcon } from "../iconBase";

export function GrPrevious(props) {
    return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "polyline", "attr": { "fill": "none", "stroke": "#000", "strokeWidth": "2", "points": "7 2 17 12 7 22", "transform": "matrix(-1 0 0 1 24 0)" } }] })(props);
};